/**
 * Author: João Lucas, 04/2020
 */
import { colors } from '../../../../theme';

/*
 * ---------------------------------------------------------
 *
 * Constantes
 *
 * ---------------------------------------------------------
 */

const urls = {
  get: {
    checkOrganization: '/v1/pub/validar_identificacao/:id',
    checkUser: '/v1/pub/verificar_cpf_usuario/:cpf/:identificacao',
    organizationInfo: '/v1/pub/convites/:identificacao/info_publico',
    phoneTypes: '/v1/pub/telefone_tipos',
    kinships: 'v1/pub/parentescos_combo',
    address: '/v1/pub/enderecos/:cep',
    genders: '/v1/pub/sexos',
  },
  post: {
    linkExistingUser: '/v1/pub/participe/:identificacao/vincular',
    resendConfirmationNumber: '/v1/pub/convites/:organization/reenvio',
    confirmation: '/v1/pub/confirmacao_cadastro/participe',
    register: '/v1/pub/participe/:hash/inscricao',
    emailChange: '/v1/pub/redefinir_email/:user',
  },
};

// Status do usuário (ZGSEG_USUARIO_STATUS_TIPO).
const UserStatus = {
  ACTIVE: 'A',
  PENDING: 'P',
  INACTIVE: 'I',
  BLOCKED: 'B',
};

// Status da associação user↔formatura (ZGSEG_USUARIO_ORGANIZACAO_STATUS).
const AssocStatus = {
  ACTIVE: 'A',
  PENDING: 'P',
  CANCELED: 'C',
  BLOCKED: 'B',
  WITHDRAWN: 'T',
  NOT_LINKED: 'NAO_VINCULADO',
};

const applet = '/p/participe';

const view = `${applet}/:organization`;

// URL curta usada quando o usuário acessa via subdomínio
// `participe.suaformatura.com/<hash>` — o nginx do coruja serve o bundle
// `publico` direto pra esse Host, e aqui o React Router resolve `/<hash>`
// como `ParticipateView` (mesmo componente da rota canônica acima).
const shortView = '/:organization';

function isSmall(width) {
  return width === 'xs' || width === 'sm' || width === 'md';
}

const HiddenBreakpoint = {
  large: { lgUp: true },
  small: { mdDown: true },
};

const Colors = {
  error: colors.danger,
  successText: colors.success,
  success: 'rgb(142, 233, 110)',
  blueBackground: 'rgba(25, 121, 151, 0.05)',
  successBackground: 'rgba(142, 233, 110, 0.1)',
  errorBackground: 'rgba(233, 142, 110, 0.1)',
};

const FormIds = {
  REGISTER: 'register',
  CONFIRMATION: 'confirmation',
  EMAIL_CHANGE: 'email-change',
};

const OrganizationCheckUp = {
  UNCHECKED: 'UNCHECKED',
  INVALID: 'INVALID',
  OK: 'OK',
};

export {
  urls,
  view,
  shortView,
  applet,
  Colors,
  isSmall,
  FormIds,
  HiddenBreakpoint,
  OrganizationCheckUp,
  UserStatus,
  AssocStatus,
};
